/** @flow */
import { spawn } from "redux-saga/effects";
import departmentSaga from "./department";
import employeeSaga from "./employee";
import managerSaga from "./manager";

export default function* focusListSaga(): Generator<*, void, void> {
  yield spawn(departmentSaga);
  yield spawn(employeeSaga);
  yield spawn(managerSaga);
}
